import { TestId } from "#/test-ids";

window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Views ??= {};

Sparkle.LocationBrowser.Views.LocationNoResults = class LocationNoResults extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
    this.reset = this.reset.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.template = this.template.bind(this);
  }

  initialize() {
    jQuery(document).on("keyup", this.handleKeyup.bind(this));
    this.listenTo(this.collection, "search", this.hide);
    return this.listenTo(this.collection, "changeScope", this.hide);
  }

  render() {
    this.$el.html(this.template());
    this.show();

    return this;
  }

  // EVENT HANDLERS

  handleResetClick() {
    return this.reset();
  }

  handleKeyup(event) {
    if (event.keyCode === 27) {
      return this.reset();
    }
  }

  // HELPER FUNCTIONS

  reset() {
    this.trigger("resetClick");
    return this.hide();
  }

  hide() {
    return this.$el.hide();
  }

  show() {
    return this.$el.show();
  }

  findClosest() {
    return this.trigger("findClosest");
  }

  template() {
    const noResults = Sparkle.LocationBrowser.t("no_results");
    const reset = `<button name='reset' class='btn' data-testid='${TestId.locationBrowser.reset}'>${Sparkle.LocationBrowser.t("reset")}</button>`;

    if (this.collection.searchParams != null ? this.collection.searchParams.range : undefined) {
      const findClosest = `<button name='find_closest' class='btn' data-testid='${TestId.locationBrowser.findClosest}'>${Sparkle.LocationBrowser.t("find_closest")}</button>`;
      return `<p>${noResults}${reset}${findClosest}</p>`;
    } else {
      return `<p>${noResults}${reset}</p>`;
    }
  }
};
Sparkle.LocationBrowser.Views.LocationNoResults.prototype.className = "lb-no-results";
Sparkle.LocationBrowser.Views.LocationNoResults.prototype.attributes = {
  "data-testid": TestId.locationBrowser.noResults,
};

Sparkle.LocationBrowser.Views.LocationNoResults.prototype.events = {
  "click [name=reset]": "handleResetClick",
  "click [name=find_closest]": "findClosest",
};
